export default "__VITE_ASSET__DM6J0OQJ__"